// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1PZ9V","bigColWidth":"Table_bigColWidth__1PpgM","biggerColWidth":"Table_biggerColWidth__vx35s","row":"Table_row__1CQN3","col":"Table_col__1Szhe"};